

/******************************************************************************/
/*     Route to Request a Repair Service IF user is Logged in on MYLG         */
/******************************************************************************/

if (window.addEventListener) {
	window.addEventListener('load', function () {
		setClickEvents();
	}, false);
} else {
	window.attachEvent('onload', function () {
		setClickEvents();
	}, false);
}

function setClickEvents() {
	$("#mobile").click(function (e) {
		if (e.preventDefault) e.preventDefault(); else (e.returnValue = false);
		window.location = "https://lgmobilerepair.com";	
		return false;
	});

	$("#other").click(function (e) {
		if (e.preventDefault) e.preventDefault(); else (e.returnValue = false);
		if ($(".mylg-status > .flag-true").length > 0) {
			window.location = "/us/support/repair-service/schedule-repair-continued-mylg";
		} else {
			$.cookie("rarRedirFlag","true", {path: '/us/support/mylg'});
			window.location = "/us/support/repair-service/schedule-repair-mylg-login";
		}
		return false;
	});
}
/******************************************************************************/
/*     Category Seldctor         */
/******************************************************************************/


var pickerBox, fncFileDown;
$(document).ready(function() {
    if (!document.querySelector(".search-model-result"))
        return !1;
    var e = $(document.querySelector(".search-model-result"))
      , b = $("#resultSelectArea")
      , l = $(".tabs-type-liner")
      , r = l.data("url")
      , n = l.find("a")
      , w = new Array
      , o = new Array
      , s = new Array
      , T = 1
      , d = {
        start: null,
        end: null
    }
      , c = {
        accordionArea: document.getElementsByClassName("result-accordion"),
        referenceToggle: function(e) {
            e.preventDefault();
            var t = $(e.target);
            t.hasClass("active") ? t.removeClass("active") : t.addClass("active"),
            t.closest(".file-reference").find(".reference-desc").collapse("toggle")
        },
        accordionToggle: function(e) {
            e.preventDefault();
            var t = $(e.target);
            t.hasClass("active") ? t.removeClass("active") : t.addClass("active"),
            t.closest(".accordion-box").find(".accordion-desc").collapse("toggle")
        },
        activeEvent: function() {
            $(c.accordionArea).find(".accordion-title .toggle_text").off("click").on("click", c.accordionToggle),
            $(c.accordionArea).find(".file-reference .link-text").off("click").on("click", c.referenceToggle),
            runChosen(),
            $(c.accordionArea).find(".sort-area select").off("change").on({
                change: function(e) {
                    e.preventDefault();
                    var t = document.getElementById("select_os_form")
                      , a = t.getAttribute("data-url")
                      , i = $(t).serialize();
                    ajax.call(a, i, "html", function(e) {
                        if (null != e.result && "downtime" == e.error.type)
                            return d.start = e.error.startTime,
                            d.end = e.error.endTime,
                            pickerBox.errorPage(null, null, !0),
                            !1;
                        $(t).find(".file-area").html(e),
                        $(c.accordionArea).find(".file-reference .link-text").off("click").on("click", c.referenceToggle)
                    }, null, "body")
                }
            }),
            $(c.accordionArea).find(".radio-button input").off("click").on({
                click: function() {
                    var t = document.getElementById("software_os_form")
                      , e = t.getAttribute("data-url")
                      , a = $(t).serialize();
                    ajax.call(e, a, "html", function(e) {
                        if (null != e.result && "downtime" == e.error.type)
                            return d.start = e.error.startTime,
                            d.end = e.error.endTime,
                            pickerBox.errorPage(null, null, !0),
                            !1;
                        $(t).find(".sync-area").html(e)
                    }, null, "body")
                }
            })
        }
    };
    $(window).on('hashchange', function() {
        if(pickerBox.previousHash != window.location.hash)
        pickerBox.hashParse(window.location.hash);
    } );
    (pickerBox = {
        previousHash: window.location.hash,
        detailURL: b.data("detail"),
        filterCPURL: b.data("filter-cp"),
        filterConsumerURL: b.data("filter"),
        filterBusinessURL: b.data("filter-b2b"),
        goBackTemp: e.find(".template .search-depth-stack .phase-reload").get(0).outerHTML,
        selectTemp: e.find(".template .search-depth-stack .change-filter").get(0).outerHTML,
        pageTemp: e.find(".template .search-depth-stack .pagination").get(0).outerHTML,
        noContentDetailTemp: e.find(".template .no-content-detail").get(0).outerHTML,
        noContentListTemp: e.find(".template .no-content-list").get(0).outerHTML,
        downtimeError: e.find(".template .error-common").get(0).outerHTML,
        init: function() {
            if (0 == b.find(".search-result-area").length)
                ajax.call(r, {}, "json", function(e, t) {
                    if (null != e.result && "downtime" == e.error.type)
                        return d.start = e.error.startTime,
                        d.end = e.error.endTime,
                        pickerBox.errorPage(null, null, !0),
                        !1;
                    $ajaxData = e,
                    pickerBox.getData($ajaxData),
                    window.location.hash != '' ? pickerBox.hashParse(window.location.hash) : pickerBox.viewList("consumer", "none")
                }, "get", "body");
            else {
                var e = b.find(".search-result-area")
                  , t = e.data("model")
                  , a = e.data("category")
                  , i = e.data("salesmodelcode")
                  , l = e.data("salessuffixcode");
                this.model(t, a, i, l),
                ajax.call(r, {}, "json", function(e, t) {
                    if (null != e.result && "downtime" == e.error.type)
                        return d.start = e.error.startTime,
                        d.end = e.error.endTime,
                        pickerBox.errorPage(null, null, !0),
                        !1;
                    $ajaxData = e,
                    pickerBox.getData($ajaxData)
                }, "get", "body")
            }
            n.on("click", function(e) {
                e.preventDefault(),
                "consumer" == $(this).data("menu") ? pickerBox.viewList("consumer", "none") : pickerBox.viewList("business", "none")
            })
        },
        getData: function(e) {
            for (var t = 0; t < e.length; t++) {
                w[e[t].type] = '<ul class="search-result-group">';
                for (var a = 0; a < e[t].list.length; a++)
                    e[t].list[a].categoryId ? w[e[t].type] = w[e[t].type] + '<li class="box-result-item"><a href="#" data-name="' + e[t].list[a].name + '" data-biztype="' + e[t].list[a].biztype + '" data-parent="' + e[t].list[a].parent + '" data-child="' + e[t].list[a].type + '" data-sort="' + e[t].list[a].sort + '" data-cate="' + e[t].list[a].categoryId + '" data-filter="' + e[t].list[a].filter + '"><div class="image-box"><span><img alt="" class="lazyload" data-src="' + e[t].list[a].image + '"></span></div><div class="text-box"><span class="name">' + e[t].list[a].name + "</span></div></a></li>" : w[e[t].type] = w[e[t].type] + '<li class="box-result-item"><a href="#" data-name="' + e[t].list[a].name + '" data-biztype="' + e[t].list[a].biztype + '" data-parent="' + e[t].list[a].parent + '" data-child="' + e[t].list[a].type + '"><div class="image-box"><span><img alt="" class="lazyload" data-src="' + e[t].list[a].image + '"></span></div><div class="text-box"><span class="name">' + e[t].list[a].name + "</span></div></a></li>";
                w[e[t].type] = w[e[t].type] + "</ul>";
                for (a = 0; a < e[t].list.length; a++)
                    o[e[t].list[a].type] = e[t].list[a].name,
                    s[e[t].list[a].type] = e[t].list[a].parent
            }
        },
        viewPreviousHTML: function(e, t, a) {
            if ("consumer" != e && "business" != e) {
                var i = '<div class="search-depth-stack">' + this.goBackTemp + "</div>";
                "consumer" != t && "business" != t && "cp" != e && (i = '<div class="search-depth-stack">' + this.goBackTemp + this.selectTemp + "</div>"),
                b.append(i).addClass("active").find(".search-depth-stack").addClass("active").find(".name-of-phase").html(o[e]),
                "DISCONTINUED" == a && (b.find(".change-filter select option:eq(0)").prop("selected", !1),
                b.find(".change-filter select option:eq(1)").prop("selected", !0)),
                b.find(".search-depth-stack .phase-reload button").on("click", function(e) {
                    e.preventDefault(),
                    pickerBox.viewList(t, "parent of parent")
                }),
                b.find(".change-filter").addClass("active").find("select").addClass("run-chosen").off("change").on("change", function() {
                    "ACTIVE" != $(this).find("option:selected").val() ? pickerBox.viewListFilter($(this).data("child"), $(this).data("parent"), 1, $(this).data("sort"), $(this).data("biztype"), $(this).data("cate"), $(this).data("filter"), "DISCONTINUED") : pickerBox.viewListFilter($(this).data("child"), $(this).data("parent"), 1, $(this).data("sort"), $(this).data("biztype"), $(this).data("cate"), $(this).data("filter"), "ACTIVE")
                }),
                runChosen()
            }
        },
        hashParse: function(a) {
            var hash = a.substring(1);
            if(hash.length > 0 ) {
                hash = hash.split('&');
                hash = hash.map(function(query){return query.split('=')[1]});
                if(hash.length == 8)
                    pickerBox.viewListFilter(hash[0], hash[1], hash[2], hash[3], hash[4], hash[5], hash[6], hash[7]);
                else if(hash.length == 2)
                    pickerBox.viewList(hash[0], hash[1]);
                else
                    pickerBox.model(hash[0], hash[1], hash[2], hash[3]);
            }
        },
        viewList: function(e, t) {
            window.location.hash = "subcat="+e+"&cat="+t;
            pickerBox.previousHash = window.location.hash;
            b.empty(),
            "consumer" != e && "business" != e && pickerBox.viewPreviousHTML(e, s[e]),
            null == w[e] && pickerBox.errorPage(null, null, !0),
            b.append(w[e]),
            "consumer" == e || "business" == e ? b.find("ul li a").on("click", function(e) {
                e.preventDefault(),
                pickerBox.viewList($(this).data("child"), $(this).data("parent")),
                adobeTrackEvent("cs-category-browse", {
                    page_event: {
                        cs_category_browse: !0
                    }
                })
            }) : b.find("ul li a").on("click", function(e) {
                e.preventDefault(),
                pickerBox.viewListFilter($(this).data("child"), $(this).data("parent"), 1, $(this).data("sort"), $(this).data("biztype"), $(this).data("cate"), $(this).data("filter"), "ACTIVE")
            }),
            pickerBox.fitAlign()
        },
        
        viewListFilter: function(f, m, h, g, v, x, y, k) {
            window.location.hash = "subcat="+f+"&cat="+m+"&page="+h+"&sort="+g+"&side="+v+"&ct="+x+"&sp="+y+"&state="+k;
            pickerBox.previousHash = window.location.hash;
            if (h && 1 != h || (b.empty(),
            k || (k = "ACTIVE"),
            pickerBox.viewPreviousHTML(f, s[f], k)),
            "cp" == f) {
                var r = b.data("category");
                ajax.call(pickerBox.filterConsumerURL + "?sort=&viewAll=Y&modelStatusCode=ACTIVE&bizType=B2C&categoryId=" + r, {}, "json", function(e, t) {
                    if (e) {
                        if (null != e.result && "downtime" == e.error.type)
                            return pickerBox.errorPage(null, null, !0),
                            !1;
                        if (w[f] = '<ul class="search-result-group model">',
                        0 < (e = e.data[0].filterList).length) {
                            w.cp = '<ul class="search-result-group cellphone-case">',
                            w.cp = w.cp + '<li class="box-result-item"><a href="#" data-parent="cp" data-child="cp_ap" data-sort="0" data-biztype="B2C" data-cate="' + r + '" data-filter="" data-name="All Phones"><div class="text-box"><span class="name">All Phones</span></div></a></li>',
                            o.cp_ap = "All Phones",
                            s.cp_ap = "cp";
                            var a = [];
                            a.id = new Array,
                            a.valueId = new Array,
                            a.valueName = new Array,
                            a.isDuplicated = new Array;
                            for (var i = 0; i < e.length; i++)
                                0 < i && e[i].filterValueName == e[i - 1].filterValueName ? a.isDuplicated[i - 1] = !0 : (a.id[i] = e[i].filterId,
                                a.valueId[i] = e[i].filterValueId,
                                a.valueName[i] = e[i].filterValueName,
                                a.isDuplicated[i] = !1);
                            
                            for (key in a.id) {
                                var l = a.isDuplicated[key] ? "V" : "";
                                w.cp = w.cp + '<li class="box-result-item"><a href="#" data-parent="cp" data-child="cp_' + key + '" data-sort="0" data-biztype="B2C" data-cate="' + r + '" data-filter="' + a.id[key] + "=" + a.valueId[key] + l + '" data-name="' + a.valueName[key] + '"><div class="text-box"><span class="name">' + a.valueName[key] + "</span></div></a></li>",
                                o["cp_" + key] = a.valueName[key],
                                s["cp_" + key] = "cp"
                            }
                            w.cp = w.cp + "</ul>",
                            b.append(w.cp),
                            bindImgError(),
                            b.find("ul li a").on("click", function(e) {
                                e.preventDefault(),
                                pickerBox.viewListFilter($(this).data("child"), $(this).data("parent"), 1, $(this).data("sort"), $(this).data("biztype"), $(this).data("cate"), $(this).data("filter"), "ACTIVE")
                            }),
                            pickerBox.fitAlign()
                        } else
                            pickerBox.errorPage(f, "list")
                    } else
                        pickerBox.errorPage(f, "list")
                }, null, "body")
            } else {
                var e, t = "", modelFilter="B";
                t = "B2B" != v.toUpperCase() ? pickerBox.filterConsumerURL : pickerBox.filterBusinessURL,
                e = y ? t + "?sort=" + g + "&viewAll=Y&categoryId=" + x + "&modelStatusCode=" + k + "&bizType=" + v.toUpperCase() + "&" + y : t + "?sort=" + g + "&viewAll=Y&categoryId=" + x + "&modelStatusCode=" + k + "&bizType=" + v.toUpperCase(),
                ajax.call(e, {}, "json", function(e, t) {
                    if (e) {
                        if (null != e.result && "downtime" == e.error.type)
                            return pickerBox.errorPage(null, null, !0),
                            !1;
                        w[f] = '<ul class="search-result-group model">';
                        var a = 15
                          , i = $(window).width();
                        a = 992 <= i ? 15 : 768 <= i ? 12 : 481 <= i ? 9 : 6;
                        var l = (e = e.data[0].productList).length;
                        if (0 < l) {
                            var r = r = a * (h - 1)
                              , n = parseInt((l - 1) / a) + 1
                              , o = parseInt((n - 1) / 5) + 1
                              , s = r + a;
                            s = l <= r + a ? l : r + a;
                            // Sanmi is changing the code for URL of each category item selected
                            // for (var d = r; d < s; d++) {
                            //     var c = e[d].userFriendlyName && null != e[d].userFriendlyName ? e[d].userFriendlyName.replace(/\"/g, "''") : e[d].userFriendlyName
                            //       , p = e[d].imageAltText && null != e[d].imageAltText ? e[d].imageAltText.replace(/\"/g, "''") : e[d].imageAltText;
                            //     w[f] = w[f] + '<li class="box-result-item"><a href="' + e[d].modelUrlPath + '" data-model="' + e[d].modelId + '" data-name="' + c + '" data-salesmodelcode="' + e[d].salesModelCode + '" data-salessuffixcode="' + e[d].salesSuffixCode + '"><div class="image-box"><span><img class="lazyload" data-src="' + e[d].mediumImageAddr + '" alt="' + p + '"></span></div><div class="text-box"><span class="name">' + c + '</span><span class="model-number">' + e[d].modelName + "</span></div></a></li>"
                            // }
                            var modelTypeArray = e.map(function(model) {
                                return model.modelType;
                            });
                            var onlyModelB = modelTypeArray.every(function(type) {
                                return type == modelFilter;
                            });
                            for (var d = r; d < s; d++) {
                                var c = e[d].userFriendlyName && null != e[d].userFriendlyName ? e[d].userFriendlyName.replace(/\"/g, "''") : e[d].userFriendlyName
                                  , p = e[d].imageAltText && null != e[d].imageAltText ? e[d].imageAltText.replace(/\"/g, "''") : e[d].imageAltText;
                                var productPSPurl = "/us/support/product/lg-" + e[d].salesModelCode + '.' + e[d].salesSuffixCode;
                                if(e[d].modelType != modelFilter)
                                    w[f] = w[f] + '<li class="box-result-item"><a href="' + productPSPurl + '" data-model="' + e[d].modelId + '" data-name="' + c + '" data-salesmodelcode="' + e[d].salesModelCode + '" data-salessuffixcode="' + e[d].salesSuffixCode + '"><div class="image-box"><span><img class="lazyload" data-src="' + e[d].mediumImageAddr + '" alt="' + p + '"></span></div><div class="text-box"><span class="name">' + c + '</span><span class="model-number">' + e[d].modelName + "</span></div></a></li>"
                            }
                            if (w[f] = w[f] + "</ul>",
                            w[f] = xssfilter(w[f], !0),
                            h && 1 != h ? b.find(".search-result-group").empty().replaceWith(w[f]) : b.append(w[f]),
                            bindImgError(),
                            1 == h) {
                                b.append(pickerBox.pageTemp);
                                for (d = 1; d <= n; d++) {
                                    var u = "";
                                    b.find(".pagination").attr("data-aria-pattern") && (u = 'aria-label="' + b.find(".pagination").attr("data-aria-pattern").replace(/\#/g, d) + '"'),
                                    1 == d ? b.find(".pagination ul").append('<li><button type="button" data-page="1" class="active" ' + u + ">1</button></li>") : b.find(".pagination ul").append('<li><button type="button" data-page="' + d + '" ' + u + ">" + d + "</button></li>")
                                }
                            }
                            if (onlyModelB == true) {
                                pickerBox.errorPage(null, null, !0);
                            }
                            // Disabled by Sanmi
                            // LGEUS-840 Start
                             b.find("ul li a").off("click").on("click", function(e) {
                                 e.preventDefault(),
                                 pickerBox.model($(this).data("model"), x, $(this).data("salesmodelcode"), $(this).data("salessuffixcode"))
                             }),
                             // LGEUS-840 End
                            pickerBox.fitAlign(),
                            b.find(".pagination ul li button").off("click").on("click", function(e) {
                                e.preventDefault();
                                var t = $(this).data("page");
                                pickerBox.viewListFilter(f, m, t, g, v, x, y, k),
                                $(this).closest(".pagination").find("li button").removeClass("active"),
                                $(this).addClass("active"),
                                b.find(".search-result-group").attr("tabIndex", 0).focus()
                            }),
                            b.find(".pagination > button").off("click").on("click", function(e) {
                                if (e.preventDefault(),
                                $(this).hasClass("prev")) {
                                    if (T <= 1)
                                        return !1;
                                    T--
                                } else {
                                    if (o <= T)
                                        return !1;
                                    T++
                                }
                                !function(e) {
                                    b.find(".pagination ul li").hide();
                                    for (var t = 5 * (e - 1); t < 5 * (e - 1) + 5; t++)
                                        b.find(".pagination ul li").eq(t).show()
                                }(T)
                            })
                        } else
                            pickerBox.errorPage(f, "list")
                    } else
                        pickerBox.errorPage(f, "list")
                }, null, "body"),
                "consumer" != m && "business" != m && "cp" != f && b.find(".change-filter select").data("child", f).data("parent", m).data("sort", g).data("biztype", v).data("cate", x).data("filter", y).data("modelStatusCode", k)
            }
        },
        model: function(i, e, t, a) {
            window.location.hash = "cusCode="+i+"&cat="+e+"&salCode="+t+"&sufCode="+a;
            pickerBox.previousHash = window.location.hash;
            var cusCode = i == "undefined" ? undefined : i;
            var cat = e == "undefined" ? undefined : e;
            var modCode = t == "undefined" ? undefined : t;
            var sufCode = a == "undefined" ? undefined : a;
            b.empty(),
            e || (e = ""),
            ajax.call(pickerBox.detailURL, {
                customerModelCode: cusCode,
                category: cat,
                salesModelCode: modCode,
                salesSuffixCode: sufCode
            }, "html", function(e, t) {
                if (current = l.find("a.active"),
                e) {
                    if (null != e.result && "downtime" == e.error.type)
                        return pickerBox.errorPage(null, null, !0),
                        !1;
                    var a = $(e);
                    b.html(a).addClass("active"),
                    c.activeEvent()
                } else
                    b.html(pickerBox.noContentDetailTemp).addClass("active").find(".red").html(xssfilter(i))
            }, null, "body")
        },
        fitAlign: function() {
            var e = b.find(".search-result-group li").length
              , t = $(window).width();
            e <= (992 <= t ? 5 : 768 <= t ? 4 : 481 <= t ? 3 : 2) ? b.find(".search-result-group").addClass("center") : b.find(".search-result-group").removeClass("center")
        },
        errorPage: function(e, t, a, i, l) {
            var r;
            "list" == t ? (r = this.noContentListTemp,
            b.append(r)) : (b.empty(),
            a ? (r = this.downtimeError,
            b.append(r),
            b.find(".start-time").text(d.start),
            b.find(".end-time").text(d.end)) : "list" == t || (r = this.noContentDetailTemp,
            pickerBox.viewPreviousHTML(e, s[e]),
            b.append(r).find(".red").html(o[e])))
        }
    }).init();
    var a = "";
    "SoftwareDrivers" == e.data("menu") ? a = "software_drivers" : "ManualsDocumnets" == e.data("menu") && (a = "manuals_documents"),
    "" != a && ($(".support-wrap .modal .pop-drivers-wrap .product-info .text .download-btn-box a.btn").on("click", function() {
        var e = changeTitleFormat($(this).closest(".product-info").find(".text .title").text()) + ":" + changeTitleFormat($(this).text());
        adobeTrackEvent("cs-popular-software-download", {
            download_file_type: a,
            download_file_name: e,
            page_event: {
                cs_file_download: !0
            }
        })
    }),
    $(".support-wrap .modal .pop-drivers-wrap .download_list ul.list li a.link-text").on("click", function() {
        var e = changeTitleFormat($(this).closest(".download_list").find(".title").text()) + ":" + changeTitleFormat($(this).text());
        adobeTrackEvent("cs-popular-software-download", {
            download_file_type: a,
            download_file_name: e,
            page_event: {
                cs_file_download: !0
            }
        })
    }),
    $(".support-wrap .popular-manuals .manuals-box .manuals-pdf-list li a").on("click", function() {
        var e = "popular_manuals:" + changeTitleFormat($(this).text());
        adobeTrackEvent("cs-popular-manuals-download", {
            download_file_type: a,
            download_file_name: e,
            page_event: {
                cs_file_download: !0
            }
        })
    }),
    $("body").on("click.adobe1", ".search-result-area .file-list li .name .link-text", function() {
        var e = changeTitleFormat($(this).closest(".accordion-box").find(".accordion-title").text()) + ":" + changeTitleFormat($(this).closest(".result-accordion").find("> .title").text()) + ":" + changeTitleFormat($(this).text());
        adobeTrackEvent("cs-detail-download", {
            download_file_type: a,
            download_file_name: e,
            page_event: {
                cs_file_download: !0
            }
        })
    }).on("click.adobe2", ".search-result-area .step-list li .btn-area a.btn", function() {
        var e = $(this).closest(".step-area").find(".step-title").text() ? $(this).closest(".step-area").find(".step-title").text() : $(this).closest(".accordion-desc").find(".desc-title").text()
          , t = changeTitleFormat(e) + ":" + changeTitleFormat($(this).closest(".result-accordion").find("> .title").text()) + ":" + changeTitleFormat($(this).text());
        adobeTrackEvent("cs-detail-download", {
            download_file_type: a,
            download_file_name: t,
            page_event: {
                cs_file_download: !0
            }
        })
    }))
});
//# sourceMappingURL=maps/select-product-category.min.js.map
